$(() => {
  // ふりがな自動入力
  $.fn.autoKana('.js-autokana-name', '.js-autokana-kana');
});
